import { Button, Form } from "react-bootstrap";
import { ChangeEvent, useState } from "react";
import { useAuth } from "../../../utils/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";

interface FormData {
  username: string;
  password: string;
  language: string;
}

export const LoginForm = () => {

  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState<FormData>({
    username: '',
    password: '',
    language: 'ca'
  });

  const [error, setError] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const { authenticate } = useAuth({
    config: {
          onError: (error) => {
            console.log(error);
      setError(error.message || t("loginError"));
      },
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.username || !formData.password) {
        setError(t("loginValidationFields"));
      return;
    }
      setError("");
    formData.language =  i18n.language
    authenticate(formData);
  };

  return (
      <Form onSubmit={handleSubmit}>
        
       <Form.Group>

        <Form.Label className="d-flex justify-content-start" >{t("loginUser")}: </Form.Label>
        <Form.Control
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label className="d-flex justify-content-start">{t("loginPassword")}: </Form.Label>
        <Form.Control
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />
      </Form.Group>

      {error && <div className="alert alert-danger mb-3">{error}</div>}

      <div>
      <button variant="primary"  type="submit">
            {t("loginButton")}
        </button>
      </div>
    </Form>
  );
}